export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_03.34d25420.jpg";